import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

interface ProgramNavigationDialogProps {
  visible: boolean;
  programName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ProgramNavigationDialog: React.FC<
  ProgramNavigationDialogProps
> = ({ visible, programName, onConfirm, onCancel }) => {
  return (
    <Dialog
      header="אישור מעבר לדף התוכנית"
      visible={visible}
      style={{ width: '450px' }}
      onHide={onCancel}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <p style={{ fontSize: '16px', marginBottom: '30px' }}>
          האם תרצה לעבור לדף התוכנית {programName}?
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <Button
            label="כן"
            icon="pi pi-check"
            className="p-button-success"
            onClick={onConfirm}
          />
          <Button
            label="לא"
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={onCancel}
          />
        </div>
      </div>
    </Dialog>
  );
};
